module.exports = __webpack_public_path__ + "img/complete2@2x.43df5e21.png";